import defaultImg from './default_img.png'
import cartDefault from './cart_default.png'

export default {
    defaultImg,
    cartDefault
} 